import { render } from "./DuplicateStylePopup.vue?vue&type=template&id=6d945e4e&scoped=true&ts=true"
import script from "./DuplicateStylePopup.vue?vue&type=script&lang=ts"
export * from "./DuplicateStylePopup.vue?vue&type=script&lang=ts"

import "./DuplicateStylePopup.vue?vue&type=style&index=0&id=6d945e4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d945e4e"]])

export default __exports__